<template>
  <el-form :model="keyWordsForm" ref="keyWordsForm" label-width="120px" class="demo-dynamic" label-position="top">
    <div class="keywords-title">
      {{$t('feed.settings.stopWords.title')}}
    </div>
    <div class="stop-keywords-list-wrap" v-if="isEnabledKeyWords" v-bar>
      <div class="keywords-list" >
        <template v-for="(item, index) in keyWordsForm.keywords">
          <el-form-item
            :prop="'keywords.' + index + '.value'"
            :key="index"
            v-if="item.enabled"
            class="keywords-list__item"
          >
            <el-input v-model="item.keyword" :placeholder="$t('feed.settings.stopWords.placeholder')">
              <i slot="suffix" class="el-input__icon el-icon-delete-solid el-icon-cursor" @click="deleteKeyWord(index)"></i>
            </el-input>
          </el-form-item>
        </template>
      </div>
    </div>
    <div class="keywords-list-un-enabled" v-else>
      {{$t('feed.settings.stopWords.empty')}}
    </div>
    <el-form-item>
      <el-button @click="addKeyWord">+ {{$t('feed.settings.stopWords.button')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: 'Keys',
    props: {
      keywords: {
        type: Array
      }
    },
    computed: {
      isEnabledKeyWords() {
        return this.keyWordsForm.keywords.filter(item => item.enabled).length;
      },
      keyWordsForm: {
        get() {
          if (!this.keywords.length) {
            this.$emit('addStopWord');
          }

          return {
            keywords: this.keywords.slice(),
          };
        },
      }
    },
    methods: {
      deleteKeyWord(index) {
        this.$emit('deleteStopWord', index);
      },
      addKeyWord() {
        this.$emit('addStopWord');
      }
    },
  };
</script>

<style>
  .stop-keywords-list-wrap {
    position: relative;
    max-height: 270px;
    margin-bottom: 15px;
    margin-right: 30px;
    overflow-y: auto!important;
    /*scrollbar-width: thin;*/
    scrollbar-color: rgb(103, 163, 227) rgb(229, 229, 226);
  }

  .stop-keywords-list-wrap::-webkit-scrollbar {
  width: 12px;
}

.stop-keywords-list-wrap::-webkit-scrollbar-track {
  background: rgb(229, 229, 226);
}

.stop-keywords-list-wrap::-webkit-scrollbar-thumb {
  background-color: rgb(103, 163, 227);
  border-radius: 20px;
  border: 3px solid rgb(229, 229, 226);
}
  .stop-keywords-list-wrap .el-form-item {
    display: inline-block;
    margin-bottom: 0;
    margin-top: 15px;
  }
  .stop-keywords-list-wrap .el-form-item:nth-child(1),
  .stop-keywords-list-wrap .el-form-item:nth-child(2),
  .stop-keywords-list-wrap .el-form-item:nth-child(3) {
    margin-top: 0;
  }
  .keywords-title {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 15px;
  }
  .keywords-list-un-enabled {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 48px;
    color: #5E6D82;
  }
  .keywords-list {
    display: flex;
    flex-wrap: wrap;
  }
  .keywords-list__item {
    margin-right: 15px;
  }
  .el-icon-cursor {
    cursor: pointer;
  }
</style>
